export default {
  get tag() {
    if (!this.tags || !this.tags.length) {
      return undefined;
    }

    return this.tags.map((g) => g.name).join(', ');
  },
};
